<template>
  <div
    class="content self_content self_c"
    style="background-color: #ebedf0;"
  >
    <!--  -->
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['My reservation']"
    />
    <div
      class="self_body self_b"
      :style="'min-height:' + window_.self_body_h + 'px;'"
    >
      <van-tabs
        @click="onClick"
        v-model="active"
      >
        <van-tab :title="window_c['coming soon']"></van-tab>
        <van-tab :title="window_c['Reservation Record']"></van-tab>
      </van-tabs>
      <van-pull-refresh
        v-model="refreshData.isLoading"
        @refresh="onRefresh"
        :pulling-text="refreshData.pullingText"
        :loosing-text="refreshData.loosingText"
        :loading-text="refreshData.loadingText"
        :success-text="refreshData.successText"
        class="s-tab_content"
        :style="'min-height:' + window_.self_body_h - 45 + 'px;'"
      >
        <van-list
          @load="onDownRefresh"
          v-model="refreshUpData.isLoading"
          :finished="refreshUpData.upFinished"
          :finished-text="refreshUpData.finishedText"
          :loading-text="refreshData.loadingText"
        >
          <van-swipe-cell
            class="self_cell_box"
            :on-close="beforeClose"
            v-for="(item, index) in bookTimeData"
            :key="index"
            :name="item.reservationId"
          >
            <van-cell
              :border="true"
              value=" "
              v-on:click="goBookUrl(item.reservationLink)"
            >
              <div class="self_box">
                <div class="self_title_box">
                  <div class="self_title_restname">{{ item.name }}</div>
                  <div class="self_title_right_box">
                    <div
                      class="self_title_right_r"
                      v-bind:style="
                        'background-color:' + statusToStr(item.state).color
                      "
                    ></div>
                    <div class="self_title_right_title">
                      {{ statusToStr(item.state).text }}
                    </div>
                    <img
                      class="self_title_right_img"
                      src="../../assets/icon/icn-back-white.png"
                    />
                  </div>
                </div>
                <div class="self_cell_line">
                  <div class="self_cell_time">
                    {{ item.day }} ({{ item.week }}) {{ item.time }}
                  </div>
                  <div class="self_cell_people">{{ item.groupSize }}人</div>
                  <div class="self_cell_name">{{ item.customerName }}</div>
                </div>
                <div class="self_cell_line self_cell_address">
                  {{ item.addressDetail }}
                </div>
              </div>
            </van-cell>
            <template
              v-if="item.state == 'reservation-canceled'"
              slot="right"
            >
              <van-button
                class="self_btn"
                square
                type="danger"
                :text="window_c['Delete']"
              />
            </template>
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/headNav";
import { getAllBookings2, deleteBooks } from "@/js/api";

import util from "@/js/util.js";
import lang_ from "@/js/locales";

export default {
  data () {
    return {
      window_c: {
        "My reservation": "餐檯預定",
        "In appointment": "預約中",
        "Already seated": "已入座",
        "reservation-table-cleaned": "已清桌",
        Canceled: "已取消",
        Delete: "刪除",
        "Are you sure to delete?": "確定刪除麼?",
        "No more data": "暫無數據~",
        Loading: "加載中...",
        "coming soon": "即將到來",
        "Reservation Record": "訂座記錄"
      },
      userInfo: {},
      window_: {
        wh: 0,
        self_body_h: 0,
        item_w: 0
      },
      refreshData: {
        // 配置下拉刷新数据
        isLoading: false,
        count: 0,
        pullingText: "下拉既可刷新...",
        loosingText: "釋放立即刷新...",
        loadingText: "加載中...",
        successText: "刷新成功"
      },
      refreshUpData: {
        isLoading: false,
        upFinished: false,
        finishedText: "沒有更多數據了..."
      },
      bookDataP: {
        brandId: "",
        memberId: "",
        pageIndex: 0,
        pageSize: 10,
        state: 1
      },
      bookTimeData: [],
      active: 0,
      color_: ""
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.color_ = this.themeColor;
    });
  },
  mounted () {
    var self = this;
    self.init_lang();
    self.init_window();
    var reservation_active = sessionStorage.reservation_active;

    if (!util.ISNULL(reservation_active)) {
      self.active = parseInt(reservation_active);
      if (parseInt(reservation_active) == 0) {
        self.bookDataP.state = 1;
        self.bookDataP.pageIndex = 0;
      } else if (parseInt(reservation_active) == 1) {
        self.bookDataP.state = 2;
        self.bookDataP.pageIndex = 0;
      }
    }
    self.getAllBookings("down");
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c["My reservation"] = lang_.t("My reservation");
      window_c["In appointment"] = lang_.t("In appointment");
      window_c["Already seated"] = lang_.t("Already seated");
      window_c["reservation-table-cleaned"] = lang_.t(
        "reservation-table-cleaned"
      );
      window_c["Canceled"] = lang_.t("Canceled");
      window_c["Delete"] = lang_.t("Delete");
      window_c["confirm"] = lang_.t("confirm");
      window_c["cancel"] = lang_.t("cancel");
      window_c["Loading"] = lang_.t("Loading");
      window_c["Are you sure to delete?"] = lang_.t("Are you sure to delete?");

      window_c["coming soon"] = lang_.t("coming soon");
      window_c["Reservation Record"] = lang_.t("Reservation Record");
      this.refreshData["pullingText"] = lang_.t("Drop down to refresh");
      this.refreshData["loosingText"] = lang_.t("Release refresh now");
      this.refreshData["successText"] = lang_.t("Refresh success");
      this.refreshData["loadingText"] = lang_.t("Loading");
      this.refreshUpData["finishedText"] = lang_.t("No more data");
      window_c["No more data"] = lang_.t("No more data");
    },
    init_window () {
      var self = this;
      let userInfoStr = util.userInfo.get(this);
      self.userInfo = JSON.parse(userInfoStr);
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      self.window_.self_body_h = h - 46;
      self.window_.item_w = w - 40;
      self.bookDataP.memberId = self.userInfo.memberId;
      self.bookDataP.brandId = util.getBrandId(self, 1);
    },
    // 查詢訂座列表
    getAllBookings (e) {
      var self = this;
      this.$toast.loading({
        message: self.window_c["Loading"],
        forbidClick: true,
        duration: 0,
        loadingType: "spinner"
      });
      var params = JSON.parse(JSON.stringify(self.bookDataP));

      if (e == "down") {
        params.pageIndex = 0;
      }
      getAllBookings2(params)
        .then(res => {
          if (res.success) {
            if (res.data.length == 0) {
              this.refreshUpData.isLoading = false;
              this.refreshUpData.upFinished = true;
            }
            if (e == "down") {
              self.refreshData.isLoading = false;
              self.refreshData.upFinished = true;
              self.bookTimeData = [];
              self.bookTimeData = res.data;
            } else {
              this.refreshUpData.isLoading = false;
              self.bookTimeData = self.bookTimeData.concat(res.data);
            }
          }
          setTimeout(function () {
            self.$toast.clear();
          }, 1000);
        })
        .catch(err => {
          console.log(err);
          setTimeout(function () {
            self.$toast.clear();
          }, 1000);
        });
    },
    onRefresh () {
      //下拉刷新回调
      this.refreshUpData.isLoading = false;
      this.refreshUpData.upFinished = false;
      this.getAllBookings("down");
    },
    onDownRefresh () {
      var pageSize = this.bookDataP.pageSize;
      this.bookDataP.pageIndex += pageSize;
      this.getAllBookings("up");
    },
    statusToStr (e) {
      var self = this;
      var text = {};
      switch (e) {
        case "reservation-created": // 已訂座
          text.text = self.window_c["In appointment"];
          text.color = "rgba(86, 172, 154,0.5)";
          break;
        case "reservation-seated": // 已入座
          text.text = self.window_c["Already seated"];
          text.color = "rgba(86, 172, 154,1)";
          break;
        case "reservation-table-cleaned": // 已完成 // 已清桌
          text.text = self.window_c["reservation-table-cleaned"];
          text.color = "#0068B7";
          break;
        case "reservation-canceled": // 已取消
          text.text = self.window_c["Canceled"];
          text.color = "rgba(134,134,134,1)";
          break;
        default:
          break;
      }
      return text;
    },
    beforeClose (position, instance, name) {
      var self = this;
      switch (position) {
        case "left":
        case "cell":
        case "outside":
          instance.close();
          break;
        case "right":
          self.$dialog
            .confirm({
              message: self.window_c["Are you sure to delete?"],
              confirmButtonText: self.window_c["cancel"],
              cancelButtonText: self.window_c["confirm"],
              cancelButtonColor: self.color_,
              confirmButtonColor: "#222"
            })
            .then(() => { })
            .catch(() => {
              // 刪除
              deleteBooks({
                reservationId: name.name
              })
                .then(res => {
                  instance.close();
                  if (res.code == "1") {
                    self.getAllBookings("down");
                  } else {
                    self.$toast({
                      message: res.errorMsg
                    });
                  }
                })
                .then(err => {
                  console.log(err);
                });
            });
          break;
      }
    },
    goBookUrl (e) {
      var self = this;
      if (!util.ISNULL(e)) {
        sessionStorage.foodStoryReservationUrl = e;
        self.$router.push({
          name: "reservation_detail",
          params: {
            arg: util.setQueryParams([util.getBrandId(self)])
          }
        });
      }
    },
    onClick (name, title) {
      var self = this;
      sessionStorage.reservation_active = name;
      self.bookTimeData = [];
      if (name == 0) {
        self.bookDataP.state = 1;
        self.bookDataP.pageIndex = 0;
        self.getAllBookings("down");
      } else if (name == 1) {
        self.bookDataP.state = 2;
        self.bookDataP.pageIndex = 0;
        self.getAllBookings("down");
      }
    }
  },

  components: {
    headNav
  }
};
</script>

<style scoped>
body {
  background-color: rgb(235, 237, 240) !important;
}

.van-tabs__line {
  width: 50% !important;
  background-color: rgb(86, 172, 154) !important;
}

.self_body .s-tab_content {
  padding: 10px !important;
  padding-top: 55px !important;
}

.self_cell_box {
  border-radius: 8px;
  margin-bottom: 8px;
  box-shadow: 0px 0px 4px #b4b4b4;
}

.self_cell_box .van-swipe-cell__wrapper {
  width: 101%;
}

.self_box {
  display: flex;
  flex-direction: column;
}

.self_title_box {
  display: flex;
  align-items: center;
  border-bottom: 1.5px dashed #e8e5e5;
  padding: 5px 0;
}

.self_cell_line {
  display: flex;
  align-items: center;
  margin-top: 13px;
}

.self_title_restname {
  font-size: 18px;
  font-weight: 500;
  color: rgba(24, 23, 23, 1);
}

.self_title_right_r {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 7.5px;
}

.self_title_right_title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(24, 23, 23, 1);
  margin-right: 11px;
}

.self_title_right_img {
  width: 16px;
  height: 16px;
}

.self_title_right_box {
  display: flex;
  margin-left: auto;
  align-items: center;
}

.self_btn {
  height: 100% !important;
  background-color: rgb(86, 172, 154) !important;
  border-color: rgb(86, 172, 154) !important;
  width: 80px;
}

.self_cell_time {
  font-size: 16px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  width: 185px;
}

.self_cell_people {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-left: auto;
  text-align: right;
  width: 35px;
}

.self_cell_name {
  font-size: 16px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  margin-left: 10px;
  width: calc(100% - 240px);
  text-align: right;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.self_cell_address {
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 11px;
}

.BG_BE1C42 {
  background-color: #be1c42;
}
.BG_BE1C42_5 {
  background: rgba(190, 28, 66, 0.5);
}
.BG_868686 {
  background-color: #868686;
}

.self_nodata {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pc_content .van-tabs {
  position: absolute !important;
}
</style>



// WEBPACK FOOTER //
// src/view/brand/reservation_list.vue